import "./Loading.css";
const Loading = () => {
  return (
    <>
      <div className="loading">로딩 중입니다...</div>
    </>
  );
};

export default Loading;
